
import BlogArticleReactionIconList from '~/components/blog/Article/Reaction/Icon/List';

export default {
  name: 'BlogArticleReaction',
  components: {
    BlogArticleReactionIconList,
  },
  props: {
    reactions: {
      type: Array,
      required: true,
    },
    iconRow: {
      type: Number,
      default: 4,
    },
    iconGap: {
      type: Number,
      default: 8,
    },
    iconWidth: {
      type: Number,
      default: 24,
    },
    enabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowPopup: false,
    }
  },
  methods: {
    onClickHandler(id) {
      this.$emit('onClick', id)
    },
  },
}
